import { ActionType } from '../../types';

export const AlarmSuggestionAcceptRejectActions = {
    AlarmSuggestionAcceptRejectStarted: () =>
        ({
            type: 'AlarmSuggestionAcceptRejected/Load/Started',
        } as const),

        AlarmSuggestionAcceptRejectSucceeded: () =>
        ({
            type: 'AlarmSuggestionAcceptRejected/Load/Succeeded',                  
        } as const),

        AlarmSuggestionAcceptRejectFailed: (errorCode: string) =>
        ({
            type: 'AlarmSuggestionAcceptRejected/Load/Failed',
            payload: { errorCode },
        } as const),
        AlarmSuggestionAcceptRejectUnmounted: () =>
        ({
            type: 'AlarmSuggestionAcceptRejected/Load/Unmounted',
        } as const),
};

export type AlarmSuggestionAcceptRejectActions = ActionType<typeof AlarmSuggestionAcceptRejectActions>;
